(() => {
  if (typeof window === 'undefined') return;

  const isCheckout =
    window.location.pathname === '/checkout' ||
    window.location.pathname.startsWith('/checkouts/');
  if (isCheckout) return;

  const prefersTouch = window.matchMedia('(hover: none)').matches;
  if (prefersTouch) return;

  const reticle = document.querySelector('[data-apex-reticle]');
  if (!reticle || reticle.dataset.apexCursorInit === 'true') return;
  reticle.dataset.apexCursorInit = 'true';

  const lerp = (start, end, amt) => start + (end - start) * amt;
  const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

  let followSpeed = parseFloat(reticle.dataset.followSpeed || '0.22');
  followSpeed = clamp(followSpeed, 0.05, 0.6);

  let targetX = window.innerWidth / 2;
  let targetY = window.innerHeight / 2;
  let currentX = targetX;
  let currentY = targetY;
  let rafId = null;
  let moveTimeout;

  const frame = () => {
    currentX = lerp(currentX, targetX, followSpeed);
    currentY = lerp(currentY, targetY, followSpeed);
    reticle.style.transform = `translate3d(${currentX}px, ${currentY}px, 0) translate(-50%, -50%)`;
    rafId = requestAnimationFrame(frame);
  };

  const showReticle = () => {
    if (!document.body.classList.contains('apex-cursor-active')) {
      document.body.classList.add('apex-cursor-active');
    }
    reticle.classList.add('is-visible');
    if (!rafId) {
      frame();
    }
  };

  const hideReticle = () => {
    reticle.classList.remove('is-visible');
    if (rafId) {
      cancelAnimationFrame(rafId);
      rafId = null;
    }
  };

  const handleMove = (event) => {
    if (reticle.style.display === 'none') return;
    targetX = event.clientX;
    targetY = event.clientY;
    showReticle();
    reticle.classList.add('is-moving');
    clearTimeout(moveTimeout);
    moveTimeout = setTimeout(() => {
      reticle.classList.remove('is-moving');
    }, 400);
  };

  document.addEventListener('mousemove', handleMove, { passive: true });

  document.addEventListener('mousedown', () => {
    reticle.classList.add('is-pressing');
  });

  document.addEventListener('mouseup', () => {
    reticle.classList.remove('is-pressing');
  });

  document.addEventListener('mouseleave', () => {
    hideReticle();
  });

  document.addEventListener('mouseenter', () => {
    if (reticle.style.display === 'none') return;
    showReticle();
  });

  window.addEventListener('blur', () => {
    hideReticle();
  });

  window.addEventListener('focus', () => {
    if (reticle.style.display === 'none') return;
    showReticle();
  });

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const applyReducedMotion = (enabled) => {
    if (enabled) {
      document.body.classList.add('apex-cursor-paused');
      hideReticle();
      reticle.style.display = 'none';
    } else {
      document.body.classList.remove('apex-cursor-paused');
      reticle.style.display = '';
      showReticle();
    }
  };

  applyReducedMotion(reducedMotion.matches);
  reducedMotion.addEventListener('change', (event) => applyReducedMotion(event.matches));
})();
